import { CAMPAIGN_STATUS } from '@/client/constant'
import {
  InstagramInstantwinPretestEntryCode,
  InstagramInstantwinPretestExpirationMinutes,
  InstagramInstantwinPretestLotteryResult
} from '@/typings/api/instagram_instantwin_pretest_entry_codes.schema'

export const INSTAGRAM_DM_TEST_DEFAULT_FORM = {
  lotteryResult: 'win' as InstagramInstantwinPretestLotteryResult,
  expirationMinutes: 180 as InstagramInstantwinPretestExpirationMinutes
}

export const INSTAGRAM_DM_TEST_EXPIRATION_OPTIONS = [
  { value: 5 as const, label: '5分' },
  { value: 30 as const, label: '30分' },
  { value: 60 as const, label: '1時間' },
  { value: 180 as const, label: '3時間' }
]

export const INSTAGRAM_DM_TEST_LOTTERY_RESULT_OPTIONS = [
  { value: 'win' as const, label: '当選' },
  { value: 'lose' as const, label: '落選' }
]

export const isInstagramDmTestDisabled = (campaignStatus?: number | null, hasRunningCampaignOnSameAccount = false) => {
  if (hasRunningCampaignOnSameAccount) {
    return true
  }

  return typeof campaignStatus === 'number' && campaignStatus !== CAMPAIGN_STATUS.BEFORE_EVENT
}

export const getInstagramDmTestButtonLabel = (current: InstagramInstantwinPretestEntryCode | null) => {
  return current ? 'テストコードを再発行' : 'テストコードを発行'
}

export const getInstagramDmTestLotteryResultLabel = (lotteryResult: InstagramInstantwinPretestLotteryResult) => {
  return lotteryResult === 'win' ? '当選' : '落選'
}

export const getInstagramDmTestCodePanelState = (
  current: InstagramInstantwinPretestEntryCode | null,
  disabled: boolean,
  isExpired: boolean = current?.isExpired ?? false
): 'empty' | 'active' | 'expired' => {
  if (!current) {
    return 'empty'
  }

  if (disabled || isExpired) {
    return 'expired'
  }

  return 'active'
}
